/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PaymentSplit } from './PaymentSplit';
import {
    PaymentSplitFromJSON,
    PaymentSplitFromJSONTyped,
    PaymentSplitToJSON,
} from './PaymentSplit';

/**
 * 
 * @export
 * @interface UsdcGate
 */
export interface UsdcGate {
    /**
     * The price in USDC needed to unlock
     * @type {number}
     * @memberof UsdcGate
     */
    price: number;
    /**
     * 
     * @type {Array<PaymentSplit>}
     * @memberof UsdcGate
     */
    splits: Array<PaymentSplit>;
}

/**
 * Check if a given object implements the UsdcGate interface.
 */
export function instanceOfUsdcGate(value: object): value is UsdcGate {
    let isInstance = true;
    isInstance = isInstance && "price" in value && value["price"] !== undefined;
    isInstance = isInstance && "splits" in value && value["splits"] !== undefined;

    return isInstance;
}

export function UsdcGateFromJSON(json: any): UsdcGate {
    return UsdcGateFromJSONTyped(json, false);
}

export function UsdcGateFromJSONTyped(json: any, ignoreDiscriminator: boolean): UsdcGate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'price': json['price'],
        'splits': ((json['splits'] as Array<any>).map(PaymentSplitFromJSON)),
    };
}

export function UsdcGateToJSON(value?: UsdcGate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'price': value.price,
        'splits': ((value.splits as Array<any>).map(PaymentSplitToJSON)),
    };
}

